export default __webpack_public_path__ + "static/carving-8931d6246dffa904b1425af3e2e83a2a.png";